import { useState } from 'react';

const DEMO_TOKEN = import.meta.env.VITE_ADMIN_DEMO_TOKEN;

/* «К проекту» — возврат на страницу проекта в витрине AIP. Если консоль
   открыта из витрины (есть window.opener), фокусируем исходную вкладку с
   живой страницей и закрываем вкладку консоли. При прямом заходе —
   обычный переход. Кнопка, а не <a href>: у ссылки браузер показывает
   URL в статус-бабле (левый нижний угол), владелец попросил этого
   не делать. */
const PROJECT_HREF = 'https://ai.alex-n8n.site/cases/ai-curator.html';

function goHome() {
  try {
    if (window.opener && !window.opener.closed) {
      window.opener.focus();
      window.close();
      return;
    }
  } catch {
    /* opener недоступен — обычный переход */
  }
  window.location.href = PROJECT_HREF;
}

function Login({ onLogin }) {
  const [token, setToken] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    setError(null);
    const trimmed = token.trim();
    if (!trimmed) {
      setError('Введите токен.');
      return;
    }
    onLogin(trimmed);
  };

  const handleDemoLogin = () => {
    setError(null);
    if (!DEMO_TOKEN) {
      setError('Демо-вход не настроен.');
      return;
    }
    onLogin(DEMO_TOKEN);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ai-bg px-4">
      <div className="ai-card w-full max-w-md p-8">
        <div className="mb-6 text-center">
          <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-ai bg-ai-primary-light text-3xl">
            ⚙️
          </div>
          <h1 className="mb-2 font-display text-2xl font-bold text-ai-text">
            AI Curator Admin Console
          </h1>
          <p className="text-sm text-ai-text-muted">
            Введите Bearer token для доступа к панели управления.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              className="mb-1 block text-sm font-medium text-ai-text-secondary"
              title="Полный доступ к панели управления — по токену оператора."
            >
              Bearer token
            </label>
            <input
              type="password"
              value={token}
              onChange={(event) => setToken(event.target.value)}
              placeholder="Вставьте токен..."
              className="ai-input w-full px-4 py-3"
            />
          </div>

          {error && (
            <div className="rounded-ai border border-ai-error/20 bg-red-500/10 p-3 text-sm text-ai-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="ai-btn w-full px-4 py-3"
          >
            Войти
          </button>

          {DEMO_TOKEN && (
            <button
              type="button"
              onClick={handleDemoLogin}
              className="ai-btn-outline w-full px-4 py-3"
              title="Демо-режим: посмотрите консоль без прав изменения (read-only)."
            >
              Войти в демо-режим (только просмотр)
            </button>
          )}

          <button
            type="button"
            onClick={goHome}
            className="ai-btn-outline ai-btn--home w-full px-4 py-3"
            title="Вернуться на страницу проекта в витрине AIP."
          >
            К проекту
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
